export default function Input({
  type,
  name,
  title,
  placeholder,
  value,
  setValue,
}) {
  return (
    <div className="w-full relative flex justify-center">
      <label
        className="absolute -top-[10px] left-3 text-[#737272] bg-white px-1 text-left text-sm"
        htmlFor={name}
      >
        {title}
      </label>
      <input
        value={value}
        onChange={({ target: { value } }) =>
          setValue(value)
        }
        name={name}
        type={type}
        placeholder={placeholder}
        className="border-[#DEDFDD] border-2 py-3 px-6 h-full w-full rounded-full text-lg"
      />
    </div>
  );
}
